import CreateEntity from "../../views/CustomerSettings/Entities/CreateEntity";

const CreateCustomerEntityPage = () => <CreateEntity />;

export default CreateCustomerEntityPage;
